import { useEffect, useRef, useCallback } from 'react'
import useAnimation from '../hooks/useAnimation'

function Canvas({ config }) {
  const containerRef = useRef(null)
  const backgroundCanvasRef = useRef(null)
  const foregroundCanvasRef = useRef(null)
  const stampCanvasRef = useRef(null)

  const { startAnimation, stopAnimation, setCanvasRefs } = useAnimation({ config })

  const handleResize = useCallback(() => {
    const container = containerRef.current
    if (!container) return

    const rect = container.getBoundingClientRect()
    const w = Math.round(rect.width)
    const h = Math.round(rect.height)

    ;[backgroundCanvasRef, foregroundCanvasRef, stampCanvasRef].forEach(ref => {
      const c = ref.current
      if (c && (c.width !== w || c.height !== h)) {
        c.width = w
        c.height = h
      }
    })
  }, [])

  useEffect(() => {
    setCanvasRefs({
      backgroundCanvas: backgroundCanvasRef.current,
      foregroundCanvas: foregroundCanvasRef.current,
      stampCanvas: stampCanvasRef.current
    })

    handleResize()
    window.addEventListener('resize', handleResize)
    startAnimation()

    return () => {
      window.removeEventListener('resize', handleResize)
      stopAnimation()
    }
  }, [])

  // Re-measure when window config changes
  useEffect(() => {
    handleResize()
  }, [config.window.width, config.window.height])

  const windowStyle = {
    width: `${config.window.width}vw`,
    height: `${config.window.height}vw`,
    borderRadius: `${config.window.borderRadius}px`
  }

  return (
    <div className="canvas-container">
      <div className="envelope-frame" ref={containerRef} style={windowStyle}>
        <canvas ref={backgroundCanvasRef} className="canvas-background" />
        <canvas ref={foregroundCanvasRef} className="canvas-foreground" />
        <canvas ref={stampCanvasRef} className="canvas-stamp" />
      </div>
    </div>
  )
}

export default Canvas
